import React, { useEffect, useState } from "react";

/**
 * Mobile-only fixed Calypso CTA bar that hides while the form is in view.
 */
export const StickyMobileCTA = ({ targetId = "audit-form", onClick }) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const target = document.getElementById(targetId);
    if (!target) return;
    const io = new IntersectionObserver(
      ([entry]) => setHidden(entry.isIntersecting),
      { threshold: 0.2 }
    );
    io.observe(target);
    return () => io.disconnect();
  }, [targetId]);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed left-0 right-0 z-50 px-4 transition-all duration-300"
      style={{
        bottom: hidden ? -80 : 12,
        opacity: hidden ? 0 : 1,
        pointerEvents: hidden ? "none" : "auto",
      }}
    >
      <button
        type="button"
        onClick={onClick}
        className="btn-calypso w-full justify-center"
        data-testid="sticky-cta-button"
      >
        Book My Audit <span className="arrow">→</span>
      </button>
    </div>
  );
};

export default StickyMobileCTA;
